import React from 'react'
import PropTypes from 'prop-types'
import { isUndefined, values } from 'lodash'
import classnames from 'classnames'
import { Col, Row } from 'react-bootstrap'

import styleMaps from '../../../shared/style-maps'
import PostCard from '../post-card'

const IMAGE_COLORS = values(styleMaps.COLORS)

const PostCardRow = (props) => {
  const { numColumns, className, posts } = props

  return (
    <Row className={className}>
      <Col sm={12}>
        {posts
          .filter((post) => post !== undefined)
          .map((post, idx) => [
            <PostCard
              key={`post_card_${post.id}`}
              navigateWithRouter={
                !isUndefined(props.navigateWithRouter)
                  ? props.navigateWithRouter
                  : true
              }
              post={post}
              numColumns={numColumns}
              title={post.title}
              image={post.featuredImage ? post.featuredImage.url : null}
              topic={
                props.showTopics && post.meta.topics
                  ? post.meta.topics.find((t) => t.slug === 'sponsored') ||
                    post.meta.topics[0]
                  : null
              }
              teaserText={post.teaserText}
              className={classnames({
                'visible-xs':
                  props.hideLastPostSm && idx === props.posts.length - 1,
              })}
            />,
            (idx + 1) % numColumns === 0 ? (
              <div key={`clear${idx + 1}`} className="clearfix hidden-xs" />
            ) : null,
          ])}
      </Col>
    </Row>
  )
}

PostCardRow.propTypes = {
  className: PropTypes.string,
  navigateWithRouter: PropTypes.bool,
  posts: PropTypes.array.isRequired,
  numColumns: PropTypes.number,
  showTopics: PropTypes.bool,
  hideLastPostSm: PropTypes.bool,
}

PostCardRow.defaultProps = {
  className: null,
  navigateWithRouter: false,
  numColumns: 4,
  hideLastPostSm: false,
  showTopics: true,
}

export default PostCardRow
